// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes blink {
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}

html {
    box-sizing: border-box;
}

[data-device="mobile"] .nolimit .desktop {
    display: none !important;
}

[data-device="desktop"] .nolimit .mobile {
    display: none !important;
}

.nolimit #game-name-version {
    /*    pointer-events: none;
        position: absolute;
        z-index: 2147483647;
        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;

       padding: 0.1em 0.4em;
        border-radius: 0.3em;
        font-size: 1.4em;
        font-weight: 100;
        opacity: 1;
        color: #ffffff;
        background-color: rgba(0, 0, 0, 0.5);

        top: 0.71em;
        right: 0.71em;
        margin-right: env(safe-area-inset-right);*/
}

.nolimit #net-position{
    pointer-events: none;
    position: absolute;
    z-index: 2147483647;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    white-space: nowrap;

    padding: 0.1em 0.4em;
    border-radius: 0.3em;
    font-size: 1.4em;
    font-weight: 100;
    opacity: 1;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.5);

    top: 1.8em;
    right: 0em;
    margin-right: env(safe-area-inset-right);
}

.nolimit * {
    position: initial;
    width: initial;
    height: initial;
    object-fit: initial;
}

html, body, .nolimit.container, .nolimit.container > .game {
    margin: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

body {
    position: fixed;
    background-color: #000;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;
}

*, *:before, *:after {
    box-sizing: inherit;
}

.blurred {
    -webkit-filter: blur(3em);
    filter: blur(3em);
}

html, button, a {
    -ms-touch-action: manipulation;
    touch-action: manipulation;
}

.nolimit.container {
    position: absolute;
}

[data-device="mobile"] .nolimit.container {
    top: 0;
    left: 0;
}

.nolimit.container.loading {
    visibility: hidden;
}

.nolimit > .fun, .nolimit > .beta, .nolimit > .replay {
    position: absolute;
    z-index: 10000;
    font-weight: 600;
    padding: 4px 8px;
    font-size: 1rem;
    top: 0;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
}

[data-device="mobile"] .nolimit > .replay {
    top: 1rem;
}

@media screen and (orientation: portrait) {
    [data-device="mobile"] .nolimit > .replay {
        font-size: 10vw;
    }
}

.nolimit > .replay {
    color: white;
    right: 0;
    font-weight: bold;
    font-size: 5vw;
    margin: 0 0.6rem;
    animation: 1.5s linear infinite blink;
    display: none;
}




.nolimit > .beta {
    color: #fbf800;
    right: 0;
    opacity: 0.7;
}

.nolimit > .game {
    text-align: center;
    position: relative;
}


.nolimit .top-label-left, .top-label-right {
    pointer-events: none;
    position: absolute;
    z-index: 2147483647;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    padding: 0.1em 0.4em;
    border-radius: 0.3em;
    font-size: 1.4em;
    font-weight: 100;
    opacity: 1;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.5);
    top: 0.71em;
}


.nolimit .top-bar-left, .top-bar-right {
    pointer-events: none;
    z-index: 2147483647;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;

    display: flex;
    flex-direction: row;
    position: absolute;
    top:1em;
}
.nolimit .top-bar-left{
    left: 1em;
    margin-left: env(safe-area-inset-left);
}
.nolimit .top-bar-left .top-bar-item  {
    margin-right: 0.5em;
}

.nolimit .top-bar-right{
    right: 1em;
    margin-right: env(safe-area-inset-right);
}
.nolimit .top-bar-right .top-bar-item  {
    margin-left: 0.5em;
}

.nolimit .top-bar-item {
    padding: 0.1em 0.4em;
    border-radius: 0.3em;
    font-size: 1.4em;
    font-weight: 100;
    opacity: 1;
    color: #ffffff;
    background-color: rgba(0, 0, 0, 0.5);
}



`, "",{"version":3,"sources":["webpack://./node_modules/@nolimitcity/game-api/src/css/main.css"],"names":[],"mappings":"AAAA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;;;;;;;;;;;;;;;;;;;kDAmB8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;;IAEnB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,oCAAoC;;IAEpC,UAAU;IACV,UAAU;IACV,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,6CAA6C;IAC7C,wIAAwI;AAC5I;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,MAAM;IACN,OAAO;AACX;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,MAAM;;IAEN,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qCAAqC;IACrC,aAAa;AACjB;;;;;AAKA;IACI,cAAc;IACd,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;;AAGA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;;IAEjB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,oCAAoC;IACpC,WAAW;AACf;;;AAGA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,2BAA2B;IAC3B,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;;IAEjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;AACX;AACA;IACI,SAAS;IACT,sCAAsC;AAC1C;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,wCAAwC;AAC5C;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,oCAAoC;AACxC","sourcesContent":["@keyframes blink {\n    0% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0;\n    }\n    100% {\n        opacity: 1;\n    }\n}\n\nhtml {\n    box-sizing: border-box;\n}\n\n[data-device=\"mobile\"] .nolimit .desktop {\n    display: none !important;\n}\n\n[data-device=\"desktop\"] .nolimit .mobile {\n    display: none !important;\n}\n\n.nolimit #game-name-version {\n    /*    pointer-events: none;\n        position: absolute;\n        z-index: 2147483647;\n        -webkit-touch-callout: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        user-select: none;\n\n       padding: 0.1em 0.4em;\n        border-radius: 0.3em;\n        font-size: 1.4em;\n        font-weight: 100;\n        opacity: 1;\n        color: #ffffff;\n        background-color: rgba(0, 0, 0, 0.5);\n\n        top: 0.71em;\n        right: 0.71em;\n        margin-right: env(safe-area-inset-right);*/\n}\n\n.nolimit #net-position{\n    pointer-events: none;\n    position: absolute;\n    z-index: 2147483647;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    white-space: nowrap;\n\n    padding: 0.1em 0.4em;\n    border-radius: 0.3em;\n    font-size: 1.4em;\n    font-weight: 100;\n    opacity: 1;\n    color: #ffffff;\n    background-color: rgba(0, 0, 0, 0.5);\n\n    top: 1.8em;\n    right: 0em;\n    margin-right: env(safe-area-inset-right);\n}\n\n.nolimit * {\n    position: initial;\n    width: initial;\n    height: initial;\n    object-fit: initial;\n}\n\nhtml, body, .nolimit.container, .nolimit.container > .game {\n    margin: 0;\n    width: 100%;\n    height: 100%;\n    overflow: hidden;\n}\n\nbody {\n    position: fixed;\n    background-color: #000;\n    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n    font-family: 'Open Sans', 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;\n}\n\n*, *:before, *:after {\n    box-sizing: inherit;\n}\n\n.blurred {\n    -webkit-filter: blur(3em);\n    filter: blur(3em);\n}\n\nhtml, button, a {\n    -ms-touch-action: manipulation;\n    touch-action: manipulation;\n}\n\n.nolimit.container {\n    position: absolute;\n}\n\n[data-device=\"mobile\"] .nolimit.container {\n    top: 0;\n    left: 0;\n}\n\n.nolimit.container.loading {\n    visibility: hidden;\n}\n\n.nolimit > .fun, .nolimit > .beta, .nolimit > .replay {\n    position: absolute;\n    z-index: 10000;\n    font-weight: 600;\n    padding: 4px 8px;\n    font-size: 1rem;\n    top: 0;\n\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n}\n\n[data-device=\"mobile\"] .nolimit > .replay {\n    top: 1rem;\n}\n\n@media screen and (orientation: portrait) {\n    [data-device=\"mobile\"] .nolimit > .replay {\n        font-size: 10vw;\n    }\n}\n\n.nolimit > .replay {\n    color: white;\n    right: 0;\n    font-weight: bold;\n    font-size: 5vw;\n    margin: 0 0.6rem;\n    animation: 1.5s linear infinite blink;\n    display: none;\n}\n\n\n\n\n.nolimit > .beta {\n    color: #fbf800;\n    right: 0;\n    opacity: 0.7;\n}\n\n.nolimit > .game {\n    text-align: center;\n    position: relative;\n}\n\n\n.nolimit .top-label-left, .top-label-right {\n    pointer-events: none;\n    position: absolute;\n    z-index: 2147483647;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    padding: 0.1em 0.4em;\n    border-radius: 0.3em;\n    font-size: 1.4em;\n    font-weight: 100;\n    opacity: 1;\n    color: #ffffff;\n    background-color: rgba(0, 0, 0, 0.5);\n    top: 0.71em;\n}\n\n\n.nolimit .top-bar-left, .top-bar-right {\n    pointer-events: none;\n    z-index: 2147483647;\n    -webkit-touch-callout: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n\n    display: flex;\n    flex-direction: row;\n    position: absolute;\n    top:1em;\n}\n.nolimit .top-bar-left{\n    left: 1em;\n    margin-left: env(safe-area-inset-left);\n}\n.nolimit .top-bar-left .top-bar-item  {\n    margin-right: 0.5em;\n}\n\n.nolimit .top-bar-right{\n    right: 1em;\n    margin-right: env(safe-area-inset-right);\n}\n.nolimit .top-bar-right .top-bar-item  {\n    margin-left: 0.5em;\n}\n\n.nolimit .top-bar-item {\n    padding: 0.1em 0.4em;\n    border-radius: 0.3em;\n    font-size: 1.4em;\n    font-weight: 100;\n    opacity: 1;\n    color: #ffffff;\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
